export type PlayerHelperPlayer = {
  id: number | null
  name: string
  score: number
  one_eighties: number
  one_seven_ones: number
  player_type: 'player'
  player_id: number
  nickname: string
  high_checkouts: string
  parent_group?: number
  parent_group_position?: number
  is_winner: boolean
}

export const getByePlayer = (): PlayerHelperPlayer => {
  return {
    id: 0,
    name: 'BYE',
    score: 0,
    one_eighties: 0,
    one_seven_ones: 0,
    player_type: 'player',
    player_id: 0,
    nickname: '',
    high_checkouts: '',
    parent_group: undefined,
    parent_group_position: undefined,
    is_winner: false,
  }
}

export const getPlayer = (player?: Player): PlayerHelperPlayer => {
  if (player) {
    return {
      id: player.id,
      name: player.name,
      score: player.score ?? 0,
      one_eighties: player.one_eighties ?? 0,
      one_seven_ones: player.one_seven_ones ?? 0,
      player_type: 'player',
      player_id: player.player_id,
      nickname: player.nickname,
      high_checkouts: player.high_checkouts ?? '',
      parent_group: player.parent_group ?? undefined,
      parent_group_position: player.parent_group_position ?? undefined,
      is_winner: player.is_winner ?? false,
    }
  }

  return {
    id: null,
    name: 'TBD',
    score: 0,
    one_eighties: 0,
    one_seven_ones: 0,
    player_type: 'player',
    player_id: 0,
    nickname: '',
    high_checkouts: '',
    parent_group: undefined,
    parent_group_position: undefined,
    is_winner: false,
  }
}
